import { ActionTypes } from "../Constants/ActionTypes";

const initialState = {
  athleteData: null,
  athleteLogo: null,
  athleteLogoId: null,
  loading: {
    pageLoading: false,
    buttonLoading: false,
    profileImageLoading: false,
  },
};

export const AthleteReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.GET_ATHLETE_DATA:
      return {
        ...state,
        athleteData: payload,
      };

    case ActionTypes.HANDLE_ATHLETE_LOGO_UPLOAD:
      return {
        ...state,
        athleteLogo: payload.filePath,
        athleteLogoId: payload.id,
      };

    case ActionTypes.DELETE_ATHLETE:
      return {
        ...state,
        athleteData: {
          ...state.athleteData,
          user: {
            ...state.athleteData.user,
            active: false,
            deleted: true,
          },
        },
      };

    case ActionTypes.ACTIVATE_INACTIVATE_ATHLETE:
      return {
        ...state,
        athleteData: {
          ...state.athleteData,
          user: {
            ...state.athleteData.user,
            active: payload,
            deleted: false,
          },
        },
      };

    case ActionTypes.SET_ATHLETE_GRADUATION_YEAR:
      return {
        ...state,
        athleteData: {
          ...state.athleteData,
          graduationYear: payload,
        },
      };

    case ActionTypes.ATHLETE_LOADING:
      return {
        ...state,
        loading: payload,
      };

    case ActionTypes.RESET_ATHLETE_DATA:
      return initialState;

    default:
      return state;
  }
};
